import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a built-in bathtub 1.7 x 0.75 x 0.55 m (length on X,
// spanning 2x1 tiles): white outer shell, a slightly darker inner floor slab
// visible from above, and a steel faucet with riser at the -X end.
const SHELL = "#f2f0ea";
const INNER = "#d8d5cf";
const STEEL = "#aab2b8";

export const bathtub = defineModel({
  id: "bathtub",
  batchId: "modern",
  name: "Bathtub",
  tags: ["modern", "interior", "fixture", "bathroom", "bathtub"],
  summary: "A built-in white bathtub with a steel faucet at one end.",
  tiles: { w: 2, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      // outer shell
      { geometry: new THREE.BoxGeometry(1.7, 0.55, 0.75), color: SHELL, position: [0, 0.275, 0] },
      // inner floor read from above (slightly darker inset slab on the top face)
      { geometry: new THREE.BoxGeometry(1.46, 0.02, 0.55), color: INNER, position: [0, 0.555, 0] },
      // faucet riser at the -X end, standing on the rim
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.18, 8), color: STEEL, position: [-0.76, 0.64, 0] },
      // faucet spout reaching over the tub
      { geometry: new THREE.BoxGeometry(0.16, 0.03, 0.035), color: STEEL, position: [-0.68, 0.715, 0] },
    ];
  },
  animations: [],
});
